export default __webpack_public_path__ + "static/media/Resistelectrical.5481b3b4.png";